import { Label, useStyles } from '@archipro-design/aria';
import * as S from '../InviteCollaboratorForm.style';
interface ShareDesignBoardDialogHeadingProp {
    title?: string;
}

const ShareDesignBoardDialogHeading = ({
    title,
}: ShareDesignBoardDialogHeadingProp) => {
    const { css } = useStyles();

    return (
        <Label className={css(S.FormHeader)} variant={'03'} weight={'medium'}>
            {title || 'Share this board'}
        </Label>
    );
};

export { ShareDesignBoardDialogHeading };
